<div fxLayout="column" class="calendar-container" 
    *ngIf="showCalendar() && !!calendar_data_last && !!calendar_data_weeks" 
    ngStyle.gt-sm="min-width:400px" ngStyle.lt-sm="min-width:320px">
    <p class="current-year" *ngIf="router.url === '/account/orders' || showCalendarDates">
        {{calendar_data_last.year}}
    </p>
    <div fxLayoutAlign="start" class="calendar-header" *ngIf="isMobile" (click)="viewCalender = !viewCalender">
        <div fxFlex fxLayout="row" fxLayoutAlign="space-between center" class="delivery-date">
            <p *ngIf="deliveryPreference" class="mat-title label">{{deliveryPreference | uppercase}} FOR</p>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px"
                class="deliveryPreference" *ngIf="deliveryPreference">
                    <!-- <p class="mat-title day">
                        <span *ngIf="!showCalendarDates">
                            {{selected_date | date:'MMM'}}&nbsp;{{selected_date | dateSuffix}},&nbsp;
                        </span>
                        {{selected_date | date:'EEEE' | uppercase}}
                    </p>
                    <mat-icon class="mat-icon-md">
                        {{showCalendarDates ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}
                    </mat-icon> -->
                    <mat-icon class="mat-icon-md Location" (click)="deliveryPreferenceoDialog()">
                    location_on
                    </mat-icon>
                    <mat-icon class="mat-icon-md" >
                        {{viewCalender ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}
                    </mat-icon> 
                </div>
                <!-- <ng-template #elseDeliveryDay>
                    <p class="mat-title day">{{selected_date | date:'EEEE' | uppercase}}</p>
                </ng-template> -->
            </div>
        </div>
    </div>
    <div fxLayout="row" class="calendar" 
        *ngIf="router.url === '/account/orders' || viewCalender" [fxHide]="!viewCalender">
        <div class="deliveryPreference deliveryprefDesk" >
            <mat-icon *ngIf="deliveryPreference" class="mat-icon-md Location" (click)="deliveryPreferenceoDialog()">
            location_on
            </mat-icon>
        </div>
        <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="0px"  class="DeliveryCalendor" *ngIf="calendar_data_weeks && calendar_data_weeks.length>0; else EmptyBlock ">
            <mat-icon class="mat-icon-lg previous" *ngIf="!disable_prev"
                (click)="changeCalendar(calendar_data_last, 'prev')">
                navigate_before
            </mat-icon>
            <div class="date" fxLayout="column" fxLayoutAlign="space-around center" 
                *ngFor="let calendar of calendar_data_weeks; index as i" 
                (click)="changeDeliveryDate(calendar)"
                [class.current]="calendar.delivery_date == selected_date"
                [class.selected]="calendar.delivery_date == selected_date">
                <p class="label mat-subheading-1">{{calendar.label}}</p>
                <p class="number mat-subheading-2">
                    {{calendar.delivery_date | date:'dd'}}
                </p>
                <!-- sale order status circle -->
                <div class="circle" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="2px"
                    *ngIf="calendar.sale_orders.length > 0; else elseSaleOrder">
                    <div *ngFor="let order_status of calendar.sale_orders" [ngClass]="order_status"></div>
                </div>
                <ng-template #elseSaleOrder>
                    <div class="circle" fxLayout="row" fxLayoutAlign="center center">
                        <div class="no-saleorder"></div>
                    </div>
                </ng-template>
                <!-- end -->
            </div>
            <mat-icon class="mat-icon-lg next" (click)="changeCalendar(calendar_data_last, 'next')" *ngIf="!disable_next">
                navigate_next
            </mat-icon>
        </div>
        <ng-template #EmptyBlock>
            <h3 class="NoEventsBlock">Once you place the order, we will discuss with you</h3>
        </ng-template>
    </div>
</div>
